const administratorInitialState = {
  name: 'Admin'
}


export default administratorInitialState;
